import { create } from 'zustand';

export const SEARCH_INDEX_STATUS = {
    Idle: 'idle',
    Hydrating: 'hydrating',
    Building: 'building',
    Ready: 'ready',
    Error: 'error',
} as const;

export type SearchIndexStatus =
    (typeof SEARCH_INDEX_STATUS)[keyof typeof SEARCH_INDEX_STATUS];

interface SearchIndexStore {
    status: SearchIndexStatus;
    lastUpdatedAt: number;
    setStatus: (status: SearchIndexStatus) => void;
    markUpdated: () => void;
}

export const useSearchIndexStore = create<SearchIndexStore>((set) => ({
    status: SEARCH_INDEX_STATUS.Idle,
    lastUpdatedAt: 0,
    setStatus: (status) => set({ status }),
    markUpdated: () => set({ lastUpdatedAt: Date.now() }),
}));
